import React, { forwardRef, useEffect, useState } from 'react'
import { propType } from 'graphql-anywhere'
import PropTypes from 'prop-types'
import ReactSVG from 'react-svg'
import classNames from 'classnames'
import USER_RATING_FRAGMENT from '../../../graphql/fragments/user-rating.gql'
import CONTENT_ITEM_FRAGMENT from '../../../graphql/fragments/content-item.gql'
import styles from './detail-rate-button.css'
import { getIconAndLabelForRateButton } from './shared'

const FADE = {
  IN: 'fadeIn',
  OUT: 'fadeOut'
}

const DetailRateButton = forwardRef(
  ({
    contentItem, userRating, isModalVisible, ...rest
  }, ref) => {
    const { ratingIcon, ratingLabel } = getIconAndLabelForRateButton(userRating)
    const [currentIconSrc, setCurrentIconSrc] = useState(ratingIcon)
    const [fadeClass, setFadeClass] = useState(FADE.IN)
    const FADE_IN_OUT_DURATION = 300 // match duration in transition for class fadeIn/fadeOut

    // eslint-disable-next-line consistent-return
    useEffect(() => {
      // when ratingIcon is changed due to chagned userRating, fade out the old icon and fade in the new icon
      if (ratingIcon !== currentIconSrc) {
        setFadeClass(FADE.OUT)
        const timeout = setTimeout(() => {
          setCurrentIconSrc(ratingIcon)
          setFadeClass(FADE.IN)
        }, FADE_IN_OUT_DURATION)
        return () => clearTimeout(timeout)
      }
    }, [ratingIcon, currentIconSrc])

    return (
      <div
        className={classNames(styles.detailRateButton, {
          [styles.isRental]: contentItem.isRental
        })}
        ref={ref}
        style={{ visibility: isModalVisible ? 'hidden' : 'visible' }}
        {...rest}
      >
        <ReactSVG
          src={currentIconSrc}
          beforeInjection={svg => {
            svg.setAttribute(
              'class',
              classNames(styles.userRatingIcon, {
                [styles.fadeIn]: fadeClass === FADE.IN,
                [styles.fadeOut]: fadeClass === FADE.OUT
              })
            )
          }}
        />
        <span className={classNames(styles.detailRateButtonLabel)}>
          {ratingLabel}
        </span>
      </div>
    )
  }
)

DetailRateButton.propTypes = {
  contentItem: propType(CONTENT_ITEM_FRAGMENT).isRequired,
  userRating: propType(USER_RATING_FRAGMENT),
  isModalVisible: PropTypes.bool
}

DetailRateButton.defaultProps = {}

export default DetailRateButton
